//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ChainlinkV3PriceProvider
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe37B8c83138caF12E57632D19c06Eb561D47e423)
 */
export const chainlinkV3PriceProviderAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: '_priceProvidersRepository',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
      { name: '_emergencyManager', internalType: 'address', type: 'address' },
      {
        name: '_quoteAggregator',
        internalType: 'contract AggregatorV3Interface',
        type: 'address',
      },
      {
        name: '_quoteAggregatorHeartbeat',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AggregatorDidNotChange' },
  { type: 'error', inputs: [], name: 'AggregatorPriceNotAvailable' },
  { type: 'error', inputs: [], name: 'AssetNotSupported' },
  { type: 'error', inputs: [], name: 'EmergencyManagerDidNotChange' },
  { type: 'error', inputs: [], name: 'EmergencyThresholdNotReached' },
  { type: 'error', inputs: [], name: 'FallbackProviderAlreadySet' },
  { type: 'error', inputs: [], name: 'FallbackProviderDidNotChange' },
  { type: 'error', inputs: [], name: 'FallbackProviderNotSet' },
  { type: 'error', inputs: [], name: 'HeartbeatDidNotChange' },
  { type: 'error', inputs: [], name: 'InvalidAggregator' },
  { type: 'error', inputs: [], name: 'InvalidAggregatorDecimals' },
  { type: 'error', inputs: [], name: 'InvalidFallbackPriceProvider' },
  { type: 'error', inputs: [], name: 'InvalidHeartbeat' },
  { type: 'error', inputs: [], name: 'OnlyEmergencyManager' },
  { type: 'error', inputs: [], name: 'QuoteAggregatorHeartbeatDidNotChange' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'aggregator',
        internalType: 'contract AggregatorV3Interface',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'AggregatorDisabled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'aggregator',
        internalType: 'contract AggregatorV3Interface',
        type: 'address',
        indexed: true,
      },
      {
        name: 'convertToQuote',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'NewAggregator',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'emergencyManager',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'NewEmergencyManager',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'fallbackProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'NewFallbackPriceProvider',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'heartbeat',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'NewHeartbeat',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'heartbeat',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'NewQuoteAggregatorHeartbeat',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EMERGENCY_PRECISION',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EMERGENCY_THRESHOLD',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'assetData',
    outputs: [
      { name: 'heartbeat', internalType: 'uint256', type: 'uint256' },
      { name: 'forceFallback', internalType: 'bool', type: 'bool' },
      { name: 'convertToQuote', internalType: 'bool', type: 'bool' },
      {
        name: 'aggregator',
        internalType: 'contract AggregatorV3Interface',
        type: 'address',
      },
      {
        name: 'fallbackProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'assetSupported',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'emergencyDisable',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'emergencyManager',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'getAggregatorPrice',
    outputs: [
      { name: 'success', internalType: 'bool', type: 'bool' },
      { name: 'price', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'getFallbackProvider',
    outputs: [
      { name: '', internalType: 'contract IPriceProvider', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'getPrice',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProviderPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProvidersRepository',
    outputs: [
      {
        name: '',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'quoteAggregatorHeartbeat',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'quoteToken',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_aggregator',
        internalType: 'contract AggregatorV3Interface',
        type: 'address',
      },
      { name: '_convertToQuote', internalType: 'bool', type: 'bool' },
    ],
    name: 'setAggregator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_emergencyManager', internalType: 'address', type: 'address' },
    ],
    name: 'setEmergencyManager',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_fallbackProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
    ],
    name: 'setFallbackPriceProvider',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      { name: '_heartbeat', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setHeartbeat',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_heartbeat', internalType: 'uint256', type: 'uint256' }],
    name: 'setQuoteAggregatorHeartbeat',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_aggregator',
        internalType: 'contract AggregatorV3Interface',
        type: 'address',
      },
      {
        name: '_fallbackProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
      { name: '_heartbeat', internalType: 'uint256', type: 'uint256' },
      { name: '_convertToQuote', internalType: 'bool', type: 'bool' },
    ],
    name: 'setupAsset',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe37B8c83138caF12E57632D19c06Eb561D47e423)
 */
export const chainlinkV3PriceProviderAddress = {
  1: '0xe37B8c83138caF12E57632D19c06Eb561D47e423',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xe37B8c83138caF12E57632D19c06Eb561D47e423)
 */
export const chainlinkV3PriceProviderConfig = {
  address: chainlinkV3PriceProviderAddress,
  abi: chainlinkV3PriceProviderAbi,
} as const
